import * as IoC from 'inversify';
import { registerQuery, registerCommand } from '@/app/tracking/common';
import { questionCommonTrackingModule } from '../common/di'
import { AnswerQuestionTrackingCommandName, QueryQuestionsTrackingQueryName } from '../api';
import { XApiAnswerQuestionCommandHandler } from './xapi-answer-question-command-handler';
import { XApiQueryQuestionsQueryHandler } from './xapi-query-questions-query-handler';
import { QuestionSuspendDataStore } from './question-suspend-data-state-store';

const questionTinCanTrackingModule = new IoC.ContainerModule((bind) => {
  registerCommand(AnswerQuestionTrackingCommandName, XApiAnswerQuestionCommandHandler, bind);
  registerQuery(QueryQuestionsTrackingQueryName, XApiQueryQuestionsQueryHandler, bind);
  bind(QuestionSuspendDataStore).toSelf().inSingletonScope();
})

export const questionTinCanTrackingModules = [
  questionCommonTrackingModule,
  questionTinCanTrackingModule
]
